/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PostureCloudModel {
    getFixupPrototypeFunction() { return PostureCloudModel.fixupPrototype; }

    static newInstance(model: Partial<PostureCloudModel>): PostureCloudModel {
        let obj = Object.assign(new PostureCloudModel(), model);
        PostureCloudModel.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PostureCloudModel>): PostureCloudModel {
        if (!model) return null;
        return PostureCloudModel.newInstance(<PostureCloudModel> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PostureCloudModel) {
        if (!obj) return;

        models.PostureCloudModel.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PostureCloudModel): boolean {
        Object.setPrototypeOf(obj, PostureCloudModel.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.total_resources === undefined) {
            this.total_resources = 0;
        }
    }

    /**
     * total resources
     */
    total_resources: number;

    /**
     * cloud name
     */
    cloud: string;

}
